module.exports = __webpack_public_path__ + "static/media/icon-comm-sms.1b373a94.svg";